import $ from 'jquery';
import {isEmpty} from 'lodash';

import {deleteCookie} from 'utils/miscs';
import removeReferrerUrl from 'utils/removeReferrerUrl';
import {getSessionUtil} from 'utils/session';

export default function setupRequestErrorFilter(logoutPageRedirectUrl) {
  $.ajaxRequests = [];
  $.ajaxRequests.abortAll = function () {
    $.ajaxRequests.forEach((jqXHR) => {
      jqXHR.abort();
    });
    $.ajaxRequests.length = 0;
  };
  $(document).ajaxSend((event, jqXHR) => {
    $.ajaxRequests.push(jqXHR);
  });
  $(document).ajaxComplete((event, jqXHR) => {
    let i = $.inArray(jqXHR, $.ajaxRequests); //  get index for current connection completed

    if (i > -1) {
      $.ajaxRequests.splice(i, 1);
    }
  });

  $(document).ajaxError((event, jqXHR) => {
    if (jqXHR.status === 401) {
      $.ajaxRequests.abortAll();
      deleteCookie('SESSIONID');
      removeReferrerUrl();
      const sessionUtil = getSessionUtil();

      if (!isEmpty(sessionUtil)) {
        sessionUtil.clearRefreshSessionInterval();
      }

      if (logoutPageRedirectUrl) {
        window.location.href = logoutPageRedirectUrl;
      } else {
        window.alert("You've been logged out");
      }
    }
  });
}
